import React from "react";
import { NavLink } from "react-router-dom";
import FooterPrivacyImg from "../assets/images/footer/DataPrivacy.svg";
import FooterSpamImg from "../assets/images/footer/zeroSpam.svg";
import FooterRatingImg from "../assets/images/footer/userRating.svg";
import FooterSslSecuredImg from "../assets/images/footer/sslSecured.svg";

const Footer = () => {
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (document.getElementById("movetop")) {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        document.getElementById("movetop").style.display = "block";
      } else {
        document.getElementById("movetop").style.display = "none";
      }
    }
  }

  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  const year = new Date().getFullYear();
  const customGridTemplateColumns = "repeat(auto-fit,minmax(160px,1fr))";
  return (
    <>
      <footer className="w3l-footer-29-main mt-4 footer-wrapper">
        <div className="max-container">
          <div className="padd-90">
            <div
              className="grid-auto-fit"
              style={{ "--grid-columns": customGridTemplateColumns }}
            >
              <div>
                <p className="roboto-bold heading16px text-secondary-color mb20">
                  COMPANY
                </p>

                <ul className="footer-list">
                  <li>
                    <NavLink to={"/about-us"}>About us</NavLink>
                  </li>
                  {/* <li>
                    <NavLink to={"/clients"}>Clients</NavLink>
                  </li> */}
                  <li>
                    <NavLink to={"/career"}>Career</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/contact-us"}>Contact us</NavLink>
                  </li>
                </ul>
              </div>

              <div>
                <p className="roboto-bold heading16px text-secondary-color mb20">
                  TRUST & COMPLIANCE
                </p>

                <ul className="footer-list">
                  {/* <li>
                    <NavLink to={"/our-data"}>Our Data</NavLink>
                  </li> */}
                  <li>
                    <NavLink to={"/privacy-policy"}>Privacy Policy</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/security-policy"}>Security Policy</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/terms-and-conditions"}>
                      Terms and Conditions
                    </NavLink>
                  </li>
                </ul>
              </div>

              <div>
                <p className="roboto-bold heading16px text-secondary-color mb20">
                  QUICK LINKS
                </p>

                <ul className="footer-list">
                  <li>
                    <NavLink to={"/features"}>Features</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/b2b-data"}>B2B Data</NavLink>
                  </li>
                  {/* <li>
                    <NavLink to={"/lead-management"}>Lead Management</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/data-outreach"}>Data Outreach</NavLink>
                  </li>
                  <li>
                    <NavLink to="/prospecting-search">
                      Prospecting Search
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={"/product-comparison"}>
                      Product Comparison
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink to={"/linkedin-extension"}>Extension</NavLink>
                  </li>
                </ul>
              </div>

              <div>
                <p className="roboto-bold heading16px text-secondary-color mb20">
                  SUPPORT
                </p>

                <ul className="footer-list">
                  <li>
                    <a href="#blog">BLOG</a>
                  </li>
                  <li>
                    <NavLink to="/faq">Faq's</NavLink>
                  </li>
                  {/* <li>
                    <a href="#resource-library">Resource Library</a>
                  </li> */}
                </ul>
              </div>

              <div>
                <p className="roboto-bold heading16px text-secondary-color mb20">
                  CONNECT WITH US
                </p>

                <ul className="footer-list">
                  <li>
                    <a href="tel:+91-9625-981200">
                      {/* <i class="fa fa-phone"></i>  */}
                      +91-9625-981200
                    </a>
                  </li>
                  <li>
                    <a href="mailto:contact@beyondleadz.ai">
                      {/* <i className="fa fa-envelope"></i>  */}
                      contact@beyondleadz.ai
                    </a>
                  </li>
                </ul>

                <div className="main-social-footer-29 mt20">
                  <a href="#facebook" className="facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://x.com/beyond_leadz" className="twitter">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: "18px" }}><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" /></svg>
                  </a>
                  <a href="https://www.linkedin.com/company/beyondleaz/">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "16px" }}><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" /></svg>
                  </a>
                  <a href="https://www.instagram.com/beyond_leadz/" className="instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>

            <div
              className="footerLogos mt60 grid-auto-fit"
              style={{ "--grid-columns": customGridTemplateColumns }}
            >
              <img
                src={FooterPrivacyImg}
                alt="logo"
                className="img-responsive"
              />
              <img src={FooterSpamImg} alt="logo" className="img-responsive" />
              <img
                src={FooterRatingImg}
                alt="logo"
                className="img-responsive"
              />
              <img
                src={FooterSslSecuredImg}
                alt="logo"
                className="img-responsive"
              />
            </div>

            <p className="mt60 text-center heading16px roboto-regular text-white">
              © {year} BeyondLeadz. All rights reserved.
            </p>
          </div>
        </div>

      </footer>
      <button onClick={topFunction} id="movetop" title="Go to top">
        <span className="fas fa-level-up-alt" aria-hidden="true"></span>
      </button>
    </>
  );
};
export default Footer;